import React, { FC } from "react";
import ErrorCover from "./error_cover.svg";

export const ErrorCoverSvg: FC = () => <img alt="ErrorCover" src={ErrorCover} />;
